'use strict';

angular.module('atex.dam').factory('DamListService', ['$q', 'UserProfileService', 'DamAclPermissionService', 'configuration', 'DamActivityService', 'DamFoldersService','ContentCacheService', 'ContentService', 'DamResolveService',
function($q, UserProfileService, DamAclPermissionService, configuration, DamActivityService, DamFoldersService, ContentCacheService, ContentService, DamResolveService) {

  var selected  = [];
  var entries   = [];
  var anchorData = {};
  var securityParentIds = {};

  ContentCacheService.get("atex.configuration.desk.restrictContent", function () {
      return ContentService.getContent({id: "atex.configuration.desk.restrictContent"})
        .then(null, function (error) {
          console.log('error fetching atex.configuration.desk.restrictContent', error);
          return error;
        });
    }
  ).then(function (configuration) {
    if (configuration) {
      if (configuration.data.aspects.contentData.data.json) {
        securityParentIds = JSON.parse(configuration.data.aspects.contentData.data.json).securityParentIds;
      }
    }
  });

  var hasObjectKeys = function(obj) {
    return obj && Object.keys(obj).length > 0;
  };

  var canRestrictOrUnRestrictContent = function(entries, isRestrict) {
    var enabled = true;
    /*
    // we can also use the web service to check if the content can be restricted or unrestricted, we will leave it
    // commented for now as a reference.
    if (isRestrict) {
      return DamRestrictContentService.canRestrictContent(entries);
    } else {
      return DamRestrictContentService.canUnRestrictContent(entries);
    }
    */
    if (entries && entries.length > 0 && hasObjectKeys(securityParentIds)) {
      var promises = entries.map(function (entry) {
        return UserProfileService.disableAction({'action': 'restrict-content', 'application': 'desk', 'data': entry._data}).then(function (disable) {
          if (disable) {
            enabled = false;
          } else {
            var securityParentId = atex.onecms.ObjectUtils.getByPath(entry._data, 'aspects/p.InsertionInfo/data/securityParentId');
            return DamResolveService.getExternalId(securityParentId).then(function (externalId) {
              var config = securityParentIds[externalId] || {};
              if (isRestrict) {
                if (!config.restrict) {
                  enabled = false;
                }
              } else {
                if (!config.unrestrict) {
                  enabled = false;
                }
              }
            });
          }
        });
      });
      return $q.all(promises).then(function () {
        return enabled;
      });
    } else {
      return $q.when(false);
    }
  };

  var canRestrictContent = function(entries) {
    return canRestrictOrUnRestrictContent(entries, true);
  };

  var canUnRestrictContent = function(entries) {
    return canRestrictOrUnRestrictContent(entries, false);
  };

  var isWebOnlyImage = function(data) {
    if (data._data) {
      return isWebOnlyImage(data._data);
    } else if (data.data) {
      return isWebOnlyImage(data.data);
    }
    var _data;
    if (data.aspects) {
      _data = data;
    } else {
      _data = { aspects: { contentData: { data: {} }}};
    }
    var contentData = _data.aspects.contentData.data;
    return contentData.objectType === 'image' && contentData.noUsePrint;
  };

  var isPrintOnlyImage = function(data) {
    if (data._data) {
      return isPrintOnlyImage(data._data);
    } else if (data.data) {
      return isPrintOnlyImage(data.data);
    }
    var _data;
    if (data.aspects) {
      _data = data;
    } else {
      _data = { aspects: { contentData: { data: {} }}};
    }
    var contentData = _data.aspects.contentData.data;
    return contentData.objectType === 'image' && contentData.noUseWeb;
  };

  return {
    getSelected : function() {
      return selected;
    },

    clearSelection : function()  {
      selected.length = 0;
    },

    getEntries : function() {
      return entries;
    },

    clearEntries : function() {
      entries.length = 0;
    },

    hasAnchor: function() {
      if ( _.isEmpty(anchorData) ) {
        return false;
      }

      return !_.isEmpty( anchorData.contentId );
    },

    addSelection : function(content)  {
      selected.push(content);
    },

    getAnchor: function() {
      return anchorData;
    },

    setAnchor: function( data ) {
      anchorData = data;
    },

    clearAnchor: function() {
      anchorData = {};
    },

    addEntries: function(newEntries) {
      Array.prototype.push.apply(entries, newEntries);
    },

    canEdit: function(entries) {
      var deferred = $q.defer();
      var canEdit = false;
      if (entries && entries.length > 0) {
        var currentType;
        canEdit = true;
        entries.forEach(function (selectedItem) {
          if (canEdit) {
            if (currentType !== undefined) {
              if (selectedItem._data.aspects.contentData.data._type !== currentType) {
                canEdit = false;
              }
            } else {
              currentType = selectedItem._data.aspects.contentData.data._type;
            }
          }
        });
      }
      if (canEdit) {
        var promises = entries.map(function (entry) {
          return UserProfileService.disableAction({'action': 'edit', 'application': 'desk', 'data': entry._data}).then(function (disable) {
            if (disable) {
              canEdit = false;
            }
          });
        });
        $q.all(promises).then(function () {
          deferred.resolve(canEdit);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canDelete: function(entries) {
      var deferred = $q.defer();
      var canDelete = false;
      if (entries && entries.length > 0) {
        var toCheck = [];
        var skipEngagmentCheck = false;
        var enabledGroupsForDeleteEngagement = configuration.getEnabledGroupsForDeleteEngagement();
        if (DamFoldersService.userInfo !== undefined && DamFoldersService.userInfo.groups !== undefined && enabledGroupsForDeleteEngagement !== undefined){
          DamFoldersService.userInfo.groups.forEach(function(group) {
            if (enabledGroupsForDeleteEngagement.includes(group.name)){
              skipEngagmentCheck = true;
            }
          });
        }
        entries.forEach(function(entry) {
          if (skipEngagmentCheck || !(entry._data.aspects.engagementAspect && entry._data.aspects.engagementAspect.data &&
            entry._data.aspects.engagementAspect.data.engagementList &&
            entry._data.aspects.engagementAspect.data.engagementList.length >0)) {
            toCheck.push(entry);
          }
        });
        if (toCheck.length > 0) {
          DamAclPermissionService.hasDeletePermissionEx(toCheck).then(function (hasPermission) {
            if (hasPermission) {
              canDelete = true;
              var promises = toCheck.map(function (entry) {
                return UserProfileService.disableAction({'action': 'delete', 'application': 'desk', 'data': entry._data}).then(function (disable) {
                  if (disable) {
                    canDelete = false;
                  }
                });
              });
              $q.all(promises).then(function () {
                deferred.resolve(canDelete);
              });
            } else {
              deferred.resolve(false);
            }
          });
        } else {
          deferred.resolve(false);
        }
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canUndelete: function(entries) {
      var deferred = $q.defer();
      var canUndelete = false;
      if (entries && entries.length > 0) {
        entries.forEach(function (entry) {
          if (entry._data.aspects['p.InsertionInfo']) {
            if (entry._data.aspects['p.InsertionInfo'].data.securityParentId === configuration.getTrashId()) {
              canUndelete = true;
            }
            deferred.resolve(canUndelete);
          } else {
            deferred.resolve(false);
          }
        });
      } else {
        deferred.resolve(false);
      }

      return deferred.promise;
    },

    canCreateJob: function(entries) {
      var deferred = $q.defer();
      if (entries && entries.length > 0) {
        var types = ['article', 'image', 'collection', 'video'];
        var promises = entries.map(function (selection) {
          var type = atex.onecms.ObjectUtils.getByPath(selection, '_data/aspects/contentData/data/objectType');
          var jobId = atex.onecms.ObjectUtils.getByPath(selection, '_data/aspects/atex.Planning/data/jobId');
          return (types.includes(type) && (!jobId));
        });
        $q.all(promises).then(function (results) {
          var canCreateJob = results.every(function (result) {
            return result;
          });
          if (canCreateJob) {
            var promises = entries.map(function (entry) {

              return UserProfileService.disableAction({'action': 'create-job', 'application': 'desk', 'data': entry._data}).then(function (disable) {
                if (disable) {
                  canCreateJob = false;
                }
              });
            });
            $q.all(promises).then(function () {
              deferred.resolve(canCreateJob);
            });
          } else {
            deferred.resolve(false);
          }
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    isWebOnlyImage: function (data) {
      return isWebOnlyImage(data);
    },

    haveWebOnlyImages: function (entries) {
      if (entries && entries.length > 0) {
        for (var idx = 0; idx < entries.length; idx++) {
          if (isWebOnlyImage(entries[idx])) {
            return true;
          }
        }
      }
      return false;
    },

    isPrintOnlyImage: function (data) {
      return isPrintOnlyImage(data);
    },

    havePrintOnlyImages: function (entries) {
      if (entries && entries.length > 0) {
        for (var idx = 0; idx < entries.length; idx++) {
          if (isPrintOnlyImage(entries[idx])) {
            return true;
          }
        }
      }
      return false;
    },

    canPublish: function(entries) {
      var deferred = $q.defer();
      var canPublish = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          if (isPrintOnlyImage(entry)) {
            canPublish = false;
            return $q.when();
          } else {
            return UserProfileService.disableAction({
              'action': 'publish',
              'application': 'desk',
              'data': entry._data
            }).then(function (disable) {
              if (disable) {
                canPublish = false;
              }
            });
          }
        });
        $q.all(promises).then(function () {
          deferred.resolve(canPublish);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canUnpublish: function(entries) {
      var deferred = $q.defer();
      var canUnpublish = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          if (isPrintOnlyImage(entry)) {
            canUnpublish = false;
            return $q.when();
          } else {
            return UserProfileService.disableAction({
              'action': 'unpublish',
              'application': 'desk',
              'data': entry._data
            }).then(function (disable) {
              if (disable) {
                canUnpublish = false;
              }
            });
          }
        });
        $q.all(promises).then(function () {
          deferred.resolve(canUnpublish);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canEngage: function(entries) {
      var deferred = $q.defer();
      var canEngage = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          return UserProfileService.disableAction({'action': 'engage', 'application': 'desk', 'data': entry._data}).then(function (disable) {
            if (disable) {
              canEngage = false;
            }
          });
        });
        $q.all(promises).then(function () {
          deferred.resolve(canEngage);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canEngageEdit: function(entries) {
      var deferred = $q.defer();
      var canEngageEdit = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          return UserProfileService.disableAction({'action': 'engage-edit', 'application': 'desk', 'data': entry._data}).then(function (disable) {
            if (disable) {
              canEngageEdit = false;
            }
          });
        });
        $q.all(promises).then(function () {
          deferred.resolve(canEngageEdit);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canEngageCopy: function(entries) {
      var deferred = $q.defer();
      var canEngageCopy = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          return UserProfileService.disableAction({'action': 'engage-copy', 'application': 'desk', 'data': entry._data}).then(function (disable) {
            if (disable) {
              canEngageCopy = false;
            }
          });
        });
        $q.all(promises).then(function () {
          deferred.resolve(canEngageCopy);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canEngageEditWithTemplate: function(entries) {
      var deferred = $q.defer();
      var canEngageEditWithTemplate = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          return UserProfileService.disableAction({'action': 'engage-edit-with-template', 'application': 'desk', 'data': entry._data}).then(function (disable) {
            if (disable) {
              canEngageEditWithTemplate = false;
            }
          });
        });
        $q.all(promises).then(function () {
          deferred.resolve(canEngageEditWithTemplate);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canCopy: function(entries) {
      var deferred = $q.defer();
      var canCopy = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          return UserProfileService.disableAction({'action': 'copy', 'application': 'desk', 'data': entry._data}).then(function (disable) {
            if (disable) {
              canCopy = false;
            }
          });
        });
        $q.all(promises).then(function () {
          deferred.resolve(canCopy);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canDuplicate: function(entries) {
      var deferred = $q.defer();
      var canDuplicate = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          return UserProfileService.disableAction({'action': 'duplicate', 'application': 'desk', 'data': entry._data}).then(function (disable) {
            if (disable) {
              canDuplicate = false;
            }
          });
        });
        $q.all(promises).then(function () {
          deferred.resolve(canDuplicate);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canClearEngagements: function(entries) {
      var deferred = $q.defer();
      var canClearEngagements = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {
          return UserProfileService.disableAction({'action': 'clear-engagements', 'application': 'desk', 'data': entry._data}).then(function (disable) {
            if (disable) {
              canClearEngagements = false;
            }
          });
        });
        $q.all(promises).then(function () {
          deferred.resolve(canClearEngagements);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canSendToArchive: function(entries) {
      var deferred = $q.defer();
      var canSendToArchive = true;
      if (entries && entries.length > 0) {
        var promises = entries.map(function (entry) {

          var contentData = entry._data.aspects.contentData.data;
          if (typeof contentData.objectType !== 'undefined') {

            return UserProfileService.disableAction({'action': 'send-to-archive', 'application': 'desk', 'data': entry._data}).then(function (disable) {
              if (disable) {
                canSendToArchive = false;
              }
            });
          }
        });
        $q.all(promises).then(function () {
          deferred.resolve(canSendToArchive);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    },

    canRestrictContent: canRestrictContent,
    canUnRestrictContent: canUnRestrictContent,
    canCreatePrintVariant: function(entries) {
      var canCreatePrintVariant = false;
      if (entries && entries.length > 0) {
        canCreatePrintVariant = true;
        for (var idx = 0; idx < entries.length; idx++) {
          if (isPrintOnlyImage(entries[idx])) {
            canCreatePrintVariant = false;
            break;
          }
        }
      }
      return $q.when(canCreatePrintVariant);
    },

    canUnlock: function(entries) {
      var deferred = $q.defer();
      var canUnlock = false;
      if (entries && entries.length > 0) {
        var promises = entries.map(function(entry){
          var edit = atex.onecms.ObjectUtils.getByPath(entry || {}, '_data/lockData/edit');
          if (edit) {
            return UserProfileService.disableAction({'action': 'unlock', 'application': 'desk', 'data': entry._data}).then(function (disable) {
              if (!disable) {
                canUnlock = true;
              }
            });
          }
        });
        $q.all(promises).then(function () {
          deferred.resolve(canUnlock);
        });
      } else {
        deferred.resolve(false);
      }
      return deferred.promise;
    }

  };

}]);
